import script from "./BidViewSaveAsDraft.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewSaveAsDraft.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewSaveAsDraft.vue?vue&type=style&index=0&id=20a89282&lang=scss"

const __exports__ = script;

export default __exports__